import React from 'react';
import {
  FormControl,
  FormLabel,
  HStack,
  RadioGroup as ChakraRadioGroup,
  Radio,
} from '@stockx/ui';

const RadioGroup = ({ label, value, options, setValue }) => (
  <FormControl mb={4}>
    <FormLabel as="legend" fontWeight={'bold'}>
      {label}
    </FormLabel>
    <ChakraRadioGroup
      defaultValue={value}
      value={value}
      onChange={(val) => setValue(val)}
    >
      <HStack spacing={2}>
        {options.map((opt, i) => {
          const id = opt.value.toString() + i.toString();
          return (
            <Radio key={i} type="radio" id={id} value={opt.value}>
              {opt.label}
            </Radio>
          );
        })}
      </HStack>
    </ChakraRadioGroup>
  </FormControl>
);

export default RadioGroup;
